import { createEdgeByShowIdQueryKey } from '../hooks/useEdgeByShowId';

const clearShowEdgeById = ({ id, queryClient } = {}) => queryClient.invalidateQueries(createEdgeByShowIdQueryKey({ id }));

export default clearShowEdgeById;